<template>
    <div class="text-nowrap">
        <b-button size="sm" v-b-tooltip.hover.top="'Show/Hide Other Details'" variant="dark"
            @click.stop="row.toggleDetails" class="mr-1">
            <i class="fa fa-eye-slash" v-if="row.detailsShowing"></i>
            <i class="fa fa-eye" v-else></i>
        </b-button>
        <b-button v-show="isAllowedToUpdate(row.item)" size="sm" variant="success" v-b-modal.edit-discrepancy-report
            v-b-tooltip.hover.top="'Mark as Resolved'" @click.stop="updateDiscrepancyReport(row.item)" class="mr-1">
            <i class="fa fa-check"></i>
        </b-button>
    </div>
</template>

<script>
import EventBus from '@/shared/event-bus';

export default {
    name: 'discrepancy-report-row-actions',
    props: {
        row: {
            type: Object,
            required: true
        },
        isSuperAdmin: {
            type: Boolean,
            required: true
        },
        isManager: {
            type: Boolean,
            required: true
        },
        isSupervisor: {
            type: Boolean,
            required: true
        },
    },
    methods: {
        updateDiscrepancyReport(item) {
            this.$store.commit('SET_CURR_SET_DISCREPANCY_REPORT', item);
            EventBus.$emit('onUpdateDiscrepancyReport', item);
        },
        isAllowedToUpdate(item) {
            return item.Status !== 'Resolved' && (this.isSuperAdmin || this.isManager || this.isSupervisor);
        }
    }
}
</script>